import React, { useState, useEffect, useMemo } from "react"
import AutoComplete from "../AutoComplete/AutoComplete"
import autoCompleteStyles from "components/AutoComplete/autoCompleteStyles"

const RowLimitSelector = ({
   onChangePageSize,
   rowLimitOptions,
   page = 1,
   pageSize = 10,
   total = 0,
}) => {
   const findMatchingOption = (value, options) =>
      options.find(
         opt => opt.value === value || (opt.value === "ALL" && value === -1)
      ) || options[0]

   const [selectedRowLimit, setSelectedRowLimit] = useState(() =>
      findMatchingOption(pageSize, rowLimitOptions)
   )

   useEffect(() => {
      setSelectedRowLimit(findMatchingOption(pageSize, rowLimitOptions))
   }, [pageSize, rowLimitOptions])

   const shownItemsCount = useMemo(() => {
      return pageSize === -1 ? total : Math.min(page * pageSize, total)
   }, [pageSize, page, total])

   const handleChange = selectedOption => {
      if (!selectedOption) return

      setSelectedRowLimit(selectedOption)

      const newPageSize =
         selectedOption.value === "ALL" ? -1 : selectedOption.value

      onChangePageSize({ target: { value: newPageSize } })
   }

   return (
      <div className="selector-container">
         <AutoComplete
            placeholder="Rows"
            value={selectedRowLimit}
            options={rowLimitOptions}
            onChange={handleChange}
            isClearable={false}
            handleOnFocus={false}
            customStyles={autoCompleteStyles.STYLE_SEVEN}
            menuPortalTarget={document.body}
         />
         <div className="selector-records">
            Showing {shownItemsCount} of {total}
         </div>
      </div>
   )
}

export default RowLimitSelector
